import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagFO = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "m48.913 25 .875-3.261a24.98 24.98 0 0 0-.649-3.261H22.826V.095c-1.109.095-2.197.264-3.26.5L15.218 3.26l-2.174-.22a25.03 25.03 0 0 0-3.261 2.124v13.313H.86a24.975 24.975 0 0 0-.649 3.26L1.087 25l-.875 3.26c.146 1.112.364 2.2.65 3.261h8.92v13.313a25.02 25.02 0 0 0 3.262 2.124l3.26-.22 3.261 2.666c1.063.236 2.152.405 3.261.5V31.521H49.14c.286-1.06.504-2.149.649-3.26L48.913 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M49.788 21.74H19.565V.593a24.83 24.83 0 0 0-6.522 2.446v18.7H.213a25.248 25.248 0 0 0 0 6.52h12.831v18.7a24.831 24.831 0 0 0 6.522 2.446V28.26h30.223a25.26 25.26 0 0 0 0-6.522Z"
}));
FlagFO.displayName = 'FlagFO';
export default withFlagWrapper(FlagFO);
//# sourceMappingURL=index.js.map